import { PROGRAM_ID } from '@metaplex-foundation/mpl-auction-house';

const AuctionHouseProgram = {
  publicKey: PROGRAM_ID
};

export { AuctionHouseProgram };
//# sourceMappingURL=AuctionHouseProgram.mjs.map
